import {
  ContactInformationForm,
  ContactInformationFormValues,
} from "@/components/campaign/setup/planning/ContactInformationForm";
import { useStepperSubmitHandlerState } from "@/utils/stepper";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/planning/contact-information",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();
  const stepper = context.useStepper();

  const step = stepper.flatStepsById["planning/contact-information"];

  const stepperContext = useMemo(() => {
    if (!step.getIsVisible(stepper.context))
      throw Error("Step is not visible with current context");
    return stepper.context;
  }, [step, stepper.context]);

  const { delivery: deliveryContext, planning: planningContext } =
    stepperContext;

  const defaultValues = useMemo(
    (): ContactInformationFormValues => ({
      deliverContacts: planningContext.deliverContacts ?? false,
      deliverContactsRequirePhone:
        planningContext.deliverContactsRequirePhone ?? false,
      deliverLiveNumber: planningContext.deliverLiveNumber ?? false,
    }),
    [
      planningContext.deliverContacts,
      planningContext.deliverContactsRequirePhone,
      planningContext.deliverLiveNumber,
    ],
  );

  const [submitHandler, setSubmitHandler] = useStepperSubmitHandlerState();

  context.stepper.useStepperSubmit(submitHandler);

  return (
    <ContactInformationForm
      configurations={stepperContext.configurations}
      exportSystem={deliveryContext.exportSystem ?? null}
      defaultValues={defaultValues}
      updateValues={(values) => {
        stepper.setContext((prev) =>
          step.getIsVisible(prev)
            ? {
                ...prev,
                planning: {
                  ...prev.planning,
                  ...values,
                },
              }
            : prev,
        );

        stepper.goNext();
      }}
      setSubmitHandler={setSubmitHandler}
      linkToContactsFilter={{
        to: "/campaigns/setup/define/$category/contacts",
        params: { category: "contacts" },
      }}
    />
  );
}
